<template>
  <section>
    <div class="sp-title">船期费用确认</div>
    <div class="sp-nav"><span class="sp-nav-item">水运业务</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">费用确认</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">船期费用确认</span></div>
    <el-form :inline="true" :model="queryForm" class="query-form demo-form-inline">
      <el-form-item label="船期:">
        <el-date-picker
          v-model="queryForm.shipTime"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态:" label-width="90px">
        <el-tag style="margin-right: 10px;cursor: pointer;" :type="querentype==item.code?'success':'info'"
                v-for="(item,index) in  receiveTypelist" :key="index" @click="selectPaymentType(item.code)"
        >{{item.name}}</el-tag>
      </el-form-item>

      <el-form-item>
        <el-button @click="onQuery" type="primary" >查询</el-button>
      </el-form-item>
    </el-form>
    <template>
      <el-table
        v-loading="tableLoading"
        class="el-table-info"
        :data="tableData1"
        stripe
        style="width: 100%"
        :show-overflow-tooltip="true"
        border
        :cell-class-name="rowClass"
      >
        <el-table-column
          prop="shipLine"
          :formatter="publicFmt"
          label="船期"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="hangci"
          :formatter="publicFmt"
          width="120"
          label="航次号"
        >
        </el-table-column>
        <el-table-column
          prop="endport"
          :formatter="publicFmt"
          label="目的港"
          width="110"
        >
        </el-table-column>
        <el-table-column
          :formatter="(row, column, cellValue, index) => { return cellValue=='1'?'未确认':(cellValue=='0'?'已确认':(cellValue=='2'?'已提交':'退回'))}"
          prop="queren"
          label="确认状态"
          width="130">
        </el-table-column>
        <el-table-column
          prop="user"
          :formatter="publicFmt"
          label="租船员"
        >
        </el-table-column>
        <el-table-column
          label="船上费用"
        >
          <template slot-scope="scope">
            <el-button   @click="showship(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="eventPage"
        style="text-align: right;padding: 10px 0px;background-color: #fff"
      >
      </el-pagination>
    </template>
    <el-dialog
      v-if="xiangqinglist.length > 0 || zhanshi"
      title="船上费用"
      :visible.sync="showAdd"
      width="70%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div style="margin-left: 5%;margin-top: -5%">
        <el-divider content-position="left">基本信息</el-divider>
        <div style="display: flex;padding: 10px 0;line-height: 10px;">
          <div class="dialog-info">
            <div class="info-title">船名：</div>
            <div class="info-text">{{jibenlist.shipname}}</div>
          </div>
          <div class="dialog-info">
            <div class="info-title">租船人：</div>
            <div class="info-text">{{jibenlist.findshipuer}}</div>
          </div>
          <div class="dialog-info">
            <div class="info-title">船舶类型：</div>
            <div class="info-text">{{jibenlist.leixing}}</div>
          </div>
        </div>
        <div style="display: flex;padding: 10px 0;line-height: 10px;">
          <div class="dialog-info">
            <div class="info-title">起运港：</div>
            <div class="info-text">{{jibenlist.startw}}</div>
          </div>
          <div class="dialog-info">
            <div class="info-title">目的港：</div>
            <div class="info-text">{{jibenlist.endw}}</div>
          </div>
          <div class="dialog-info">
            <div class="info-title">离港日期：</div>
            <div class="info-text">{{myFmtDateTime(jibenlist.leaved,'YYYY/MM/DD')}}</div>
          </div>
        </div>
        <el-divider content-position="left">船舶支出</el-divider>
        <div style="display: flex;padding: 10px 0;line-height: 10px;">
          <div class="dialog-info info-margin">
            <div class="info-title">港使费：</div>
            <div class="info-text">{{this.xiangqinglist[0].gangshi}}</div>
          </div>
          <div class="dialog-info">
            <div class="info-title">打标记：</div>
            <div class="info-text">{{this.xiangqinglist[0].biaoji}}</div>
          </div>

        </div>

        <div style="display: flex;padding: 10px 0;line-height: 10px;">
          <div class="dialog-info info-margin">
            <div class="info-title">垫料费：</div>
            <div class="info-text">{{this.xiangqinglist[0].dianliao}}</div>
          </div>
          <div class="dialog-info">
            <div class="info-title">绑扎费：</div>
            <div class="info-text">{{this.xiangqinglist[0].bangza}}</div>
          </div>
        </div>
        <div style="display: flex;padding: 10px 0;line-height: 10px;">
          <div class="dialog-info">
            <div class="info-title">其他：</div>
            <div class="info-text">{{this.xiangqinglist[0].qitamoney}}</div>
          </div>
        </div>

        <el-divider content-position="left">船舶收入</el-divider>
        <div style="display: flex;padding: 10px 0;line-height: 10px;">
          <div class="dialog-info">
            <div class="info-title">收入：</div>
            <div class="info-text">{{this.xiangqinglist[0].shouru}}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="width: 100%; text-align: center" v-if="userid === username">
        <el-button v-if="this.xiangqinglist[0].queren === 2" @click="queren" type="danger" style="width: 30%">确认</el-button>
        <el-button v-if="this.xiangqinglist[0].queren !== 3" @click="tuihuiliyou" type="danger" style="width: 30%">退回</el-button>
        <el-button v-if="this.xiangqinglist[0].queren === 0"  disabled type="danger" style="width: 30%">已确认</el-button>
        <el-button v-if="this.xiangqinglist[0].queren === 3"  disabled type="danger" style="width: 30%">已退回</el-button>

      </div>
    </el-dialog>
    <el-dialog
      title="驳回理由"
      :visible.sync="showAdd1"
      width="30%"
      class="eldialog"
      :before-close="handleClose1"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="退回理由"
        v-model="reason">
      </el-input>
      <div style="text-align: right;margin-top: 10px">
        <el-button @click="tuihui" type="primary">确认</el-button>
        <el-button @click="handleClose" type="primary">返回</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>

  import {ERR_OK} from "../jslib/config";
  import dayjs from 'dayjs';
  import {
    fmtDictionary,
    fmtDateTime,
  } from "../jslib/util";
  import {getUser,getUserInfoById} from "../api/user";
  import WorkFlowProcessDrawer from "../components/workflow/process";
  import {getDictionaryList} from "../api/sysdictionary";
  import {getluruchuanqi,updateShipLine,getShipLineById,getShipfeiyongbyId} from "../api/shipline";
  import {getShipLineTransPayList,updateShipPay,} from "../api/shiplinetranspay"


  export default {
    data() {
      return {
        showAdd1:false,
        receiveTypelist:[
          {
            name:"待确认",
            code:2
          },
          {
            name:"已确认",
            code:0
          },
          {
            name:"退回",
            code:3
          }
        ],
        tableLoading:true,
        paylist:[],
        transpay:[],
        shiplinelist:[],
        xiangqinglist:[],
        queryForm:{},
        tableData1:[],
        shiplineid:"",
        tableData:[],
        listcost:[],
        listpay:[],
        tableData2:[],
        total:0,
        pageNum:1,
        pageSize: 10,
        showAdd:false,
        radio: '付款详情',
        info:{},
        updateShip:[],
        zhanshi:false,
        querydata:{},
        confrim:[],
        confid:"",
        reason:"",
        jibenlist:[],
        querentype:null,
        userid:"",
        username:""
      };
    },
    created() {
      getUser().then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.userid = res.user.name
          console.log(this.userid)
        }
      });
      this.tableLoading =true
      this.getyemian(1)
      getDictionaryList("cost_type,goods_type,goods_source,undertaker,items_occurred,bill_tax,mai_company,dian_company,contract_company").then((res) => {
        if (res != undefined && res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map;
        }
      });
    },
    mounted() {
    },
    methods: {
      selectPaymentType(id){
        if(this.querentype === id){
          this.querentype=null
        } else {
          this.querentype = id
        }
      },
      getyemian(pageNum){
        var startshipTime = null;
        var endshipTime = null;
        if (
          this.queryForm.shipTime != undefined &&
          this.queryForm.shipTime != null
        ) {
          startshipTime = this.queryForm.shipTime[0];
          endshipTime = this.queryForm.shipTime[1];
        }
        getluruchuanqi(1,pageNum,this.pageSize,startshipTime,endshipTime,1,this.querentype).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.tableData1 = res.zhanshi.rows
            this.total = res.zhanshi.total
            this.listcost = res.cost
            this.listpay = res.pay
            console.log(res)
          }
        }).finally(()=>{
          this.tableLoading = false
        })
      },
      jump(){
        this.$router.push("/stwagedefineDetail")
      },
      refresh() {
        // 审批完成后会调用刷新方法
      },
      handlerGlobalParams(globalParams){
        // 这里是右侧划出审批页面并且请求完数据，返回的全局参数，参考 本组件 132～136 行代码
        console.log(globalParams);
      },
      tongguo(res){
        this.$confirm('确认通过请求?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData[res].status = 0
        })
      },
      publicFmt(row,column,cellValue,index){
        var v = '--'
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          v = cellValue
        }
        return v
      },
      queren(){
        this.$confirm('是否确认费用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.querydata.shipLineId = this.shiplineid
          updateShipPay(this.querydata).then(console.log(1))
          getShipLineById(this.shiplineid).then(res =>{
            this.updateShip = res.data
            this.updateShip.queren = 0
            updateShipLine(this.updateShip).then(ress =>{
              if (ress!=undefined&&ress.resultCode === ERR_OK) {
                this.$message({
                  type: 'success',
                  message: '确认成功!'
                });
                this.handleClose()
                this.getyemian(this.pageNum)
              }
            })
          })
        })
      },
      changeRadio(item){
        console.info(item)
      },
      handleClose(){
        this.showAdd = false;
        this.xiangqinglist = []
      },
      showship(res){
        this.username = res.user
        console.log(res)
        this.shiplineid = res.id
        var querydata = {
          shiplineId: this.shiplineid,
          pageNum: 1,
          pageSize: 10,
        }
        getShipLineById(this.shiplineid).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.shiplinelist = res.data
            console.log(this.shiplinelist)
          }
        })
        getShipfeiyongbyId(this.shiplineid).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.transpay = res.transpay
            this.jibenlist = res.message
            console.log(this.transpay)
          }
        })
        getShipLineTransPayList(querydata).then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            if(res.page==undefined||res.page.records==undefined){
              return
            }
            this.paylist = res.page.records
          }
        })

        this.showAdd = true
        this.listpay.forEach(ress =>{
          if (ress.shipLineId === res.id){
            console.log(ress)
            this.xiangqinglist.push(
              {
                "gangshi":res.gangshi,
                "bangza":res.bangza,
                "dianliao":res.dianliao,
                "biaoji": res.biaoji,
                "qitamoney": res.qitamoney,
                "shipmoney": ress.shipPay,
                "shipcompany": ress.company,
                "kaipiaomoney": ress.ticketPrice,
                "kaipiaocompany": ress.inputBill,
                "dianzimoney": ress.ticketPrice1,
                "dianzicompany": ress.inputBill1,
                "queren":res.queren,
                "shouru":res.shouru,
                "fankuan":res.shipfan,
              })
          }
        })
        if (this.xiangqinglist.length === 0) {
          this.xiangqinglist.push(
            {
              "gangshi":"",
              "bangza":"",
              "dianliao":"",
              "biaoji": "",
              "qitamoney": "",
              "shipmoney": "",
              "shipcompany": "",
              "kaipiaomoney": "",
              "kaipiaocompany": "",
              "dianzimoney": "",
              "dianzicompany": "",
              "queren":"",
            })
        }
        console.log(this.xiangqinglist)
      },
      eventPage(e){
        this.pageNum = e;
        this.getyemian(e);
      },
      onQuery(){
        this.getyemian(1);
      },
      applyVerify(item){
        this.$refs.processDrawer1.drawer = true
        this.$refs.processDrawer1.processId = '1284044773845401601' // 参考 本组件 142 行代码
        this.$refs.processDrawer1.title = 'xxx提交的审批'
        this.$refs.processDrawer1.doInit()
        this.showAdd = true;
        this.info = Object.assign({},item)
      },
      rowClass({row, column, rowIndex, columnIndex}){
        if((row.status == 0 || row.status ==1) && columnIndex == 7 ){
          return 'warning-cell'
        } else if(row.status == 2 && columnIndex == 7){
          return 'success-cell'
        }
        return '';
      },
      tuihuiliyou(){
        this.showAdd1 = true
        this.reason = ""
        this.confid = this.shiplineid
      },
      tuihui(){
        getShipLineById(this.confid).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.confrim = res.data
            this.confrim.queren = 3
            this.confrim.reason = this.reason
            updateShipLine(this.confrim).then(res =>{
              if (res!=undefined&&res.resultCode === ERR_OK) {
                this.$message({
                  type: 'success',
                  message: '驳回完成!'
                });
                this.getyemian(this.pageNum)
                this.handleClose()
                this.handleClose1()
              }
            })
          }
        })
      },
      myFmtDateTime(cellValue, fmtstr) {
        if (cellValue == undefined || cellValue == null || cellValue == "") {
          return "--";
        }
        return dayjs(cellValue).format(fmtstr)
      },
      dian_companyFmt(cellValue) {
        return fmtDictionary(cellValue, this.dictionaryLists["dian_company"]);
      },
      mai_companyFmt(cellValue){
        return fmtDictionary(cellValue, this.dictionaryLists["contract_company"]);
      },
      bill_taxFmt(cellValue) {
        return fmtDictionary(cellValue, this.dictionaryLists["bill_tax"]);
      },
      handleClose1(){
        this.showAdd1 = false
      }
    },
    computed: {},
    components: {WorkFlowProcessDrawer}
  }
</script>

<style scoped>
  .query-form{
    text-align: left;
    padding-top: 10px;
  }
  .sp_add_left{
    width: 45%;
    margin-right: 5%;
  }
  .sp_add_right{
    width: 45%;
  }
  .el-table-info >>> .cell{
    text-align: center;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }
  .mytable td  {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .mytable td .cell {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }
  .el-table-info >>> .warning-cell{
    color: red;
  }
  .el-table-info >>> .success-cell{
    color: #6DD400;
  }
  .dialog-info{
    width: 50%;
    display: flex;
  }
  .dialog-info-left{
    width: 60%;
    display: flex;
  }
  .dialog-info-right{
    width: 40%;
    display: flex;
  }
  .info-title{
    text-align: left;
  }
  .info-text{
    text-align: left;
    color: #2cb7fd;
  }
  .myStep >>>.el-step__main{
    margin-top: 10px;
  }
</style>
